import { Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';

import type { IProfileCreate } from '../types';

import { useProfileCreate } from '../queries';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';
import { FormCommon } from './FormCommon';

export const ProfileCreate = (): JSX.Element => {
  const { t } = useTranslation();
  const [form] = Form.useForm<IProfileCreate>();
  const { mutate: profileCreate, isLoading } = useProfileCreate();

  const submitHandler = (data: IProfileCreate) => {
    profileCreate(data);
  };

  return (
    <>
      <PageHeader
        title={t('profiles.form.createTitle')}
        description={t('profiles.form.createDescription')}
        navigateBackUrl={routes.profiles()}
      />
      <Form
        name='profileCreate'
        form={form}
        requiredMark='optional'
        layout='vertical'
        onFinish={submitHandler}
        scrollToFirstError
      >
        <FormCommon />

        <Form.Item>
          <Button type='primary' htmlType='submit' loading={isLoading}>
            {t('global.save')}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};
